import { createContext } from 'react';
// import { useStateManager } from '../hooks/useStateManager';

const defaultState: any = [];

const SalesExecutiveContext = createContext(defaultState);

export default SalesExecutiveContext;
